import { render } from "./PointControl.vue?vue&type=template&id=042196b2&scoped=true"
import script from "./PointControl.vue?vue&type=script&lang=js"
export * from "./PointControl.vue?vue&type=script&lang=js"

import "./PointControl.vue?vue&type=style&index=0&id=042196b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042196b2"]])

export default __exports__